import React from 'react'
import PropTypes from 'prop-types'
import { injectIntl } from 'react-intl'

import { Text, Stack, Flex, Center } from '@chakra-ui/react'

import FontAwesomeIconComponent from 'src/components/FontAwesomeIcon/index'
import styles from '../styles.module.less'
import intlMessages from '../translations'
import { handleKeyDown } from 'src/utils/helpers'

const DocumentCard = ({ document, intl, onSelected }) => {
  const handleClick = e => {
    e.preventDefault()

    if (typeof onSelected === 'function') {
      onSelected(document)
    }
  }

  let docTypeIcon = ['fal', 'file-lines']
  if (document.extension === 'doc') {
    docTypeIcon = ['far', 'file-lines']
  }
  if (document.extension === 'gif') {
    docTypeIcon = ['fal', 'file-image']
  }
  if (document.extension === 'jpg') {
    docTypeIcon = ['fal', 'file-lines']
  }
  if (document.extension === 'pdf') {
    docTypeIcon = ['far', 'file-pdf']
  }

  return (
    <Stack className={styles.cardLayout}>
      <Stack
        onClick={handleClick}
        className={styles.card + ' ' + styles.documentCard}
        tabIndex='0'
        onKeyDown={handleKeyDown(handleClick)}
      >
        <Flex align={'center'}>
          <Flex className={styles.topLeft} direction={'row'} align={'center'}>
            <FontAwesomeIconComponent icon={docTypeIcon} size='xs' type='card-font' />
            <Text
              variant='card'
              ml={'5px'}
              fontSize={'14px'}
              fontWeight={'bold'}
              textTransform={'uppercase'}
              className={styles.cardTitle}
            >
              {document.extension}
            </Text>
          </Flex>
        </Flex>
        <Flex mt={'15px'} direction={'column'} justify={'center'} align={'center'}>
          {document.hasOwnProperty('policyNumber') && document.policyNumber && (
            <Text variant='card' fontSize={'14px'} textTransform={'uppercase'}>
              {document.policyNumber}
            </Text>
          )}
          {document.hasOwnProperty('description') && document.description && (
            <Text
              width={'100%'}
              textAlign={'center'}
              variant='card'
              mt={'5px'}
              fontSize={'16px'}
              fontWeight={'bold'}
            >
              {document.description}
            </Text>
          )}
          {document.hasOwnProperty('extraInfo') && document.extraInfo && (
            <Text
              variant='card'
              my={'15px'}
              opacity={0.5}
              fontSize={'14px'}
              textTransform={'uppercase'}
            >
              {document.extraInfo}
            </Text>
          )}
        </Flex>
        <Flex direction={'column'} justify={'center'} align={'center'}>
          <Flex direction={'row'} align={'center'} opacity={0.5}>
            <Flex>
              <FontAwesomeIconComponent
                icon={['far', 'calendar-check']}
                size='xs'
                type='card-font'
              />
            </Flex>
            <Text variant='card' mx={'5px'} fontSize={'14px'}>
              {intl.formatMessage(intlMessages.documentsDateDateAdded)}
            </Text>
          </Flex>
          <Center>
            <Text variant='card' fontWeight={'bold'} textTransform={'uppercase'} fontSize={'14px'}>
              {document.dateAdded || '-'}
            </Text>
          </Center>
        </Flex>
      </Stack>
    </Stack>
  )
}

DocumentCard.propTypes = {
  document: PropTypes.object.isRequired,
  onSelected: PropTypes.func,
}

export default injectIntl(DocumentCard)
